var map = {
	"./capa-padrao-direito.png": "9844",
	"./capa-padrao-educacao.png": "3cf1",
	"./capa-padrao-livro.png": "f46b",
	"./capa-padrao-saude.png": "fd70",
	"./capa-padrao-simulado.png": "8b2e",
	"./capa-padrao-tecnologia.png": "610b",
	"./capa-padrao-video.png": "35cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b86";